function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import Modal from 'components/Modal';
import App from 'modules/App';
import { useAction } from 'hooks';
import Button from 'components/Form/Button';
import messages from 'modules/Patient/messages';
import * as constants from '../../constants';
import * as selectors from '../../selectors';
import useEnrollInClinic from '../../partials/EnrollInClinic/useEnrollInClinic';
const EnrollInClinicModal = ()=>{
    const openModalId = useSelector(App.selectors.modal);
    const onCloseModal = useAction(App.actions.closeModal);
    const isInProgress = useSelector(selectors.isEnrollInClinicInProgress);
    let handleSetIsSucceed;
    const onCancel = async ()=>{
        await onCloseModal();
        handleSetIsSucceed(false);
    };
    const { isSucceed, setIsSucceed, infoMessages, headerMessages, renderEnrollInClinicForm } = useEnrollInClinic(onCancel);
    handleSetIsSucceed = setIsSucceed;
    const renderInfo = ()=>{
        const Info = isSucceed ? infoMessages.waitForRequestAccepted : infoMessages.provideEnrollCode;
        return /*#__PURE__*/ _jsx("div", {
            className: "modal__info mb-5",
            children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, Info))
        });
    };
    const renderCloseBtn = ()=>/*#__PURE__*/ _jsx(Button, {
            styleModifier: "primary",
            labelMessage: messages.buttons.close,
            className: "btn--block btn--filled",
            onClick: onCancel
        });
    return /*#__PURE__*/ _jsxs(Modal, {
        modalId: constants.ENROLL_IN_CLINIC_MODAL,
        headerMessage: isSucceed ? headerMessages.waitForRequestAccepted : headerMessages.enrollInClinic,
        openModalId: openModalId,
        styleModifier: "md",
        isInProgress: isInProgress,
        onClose: onCancel,
        children: [
            renderInfo(),
            isSucceed ? renderCloseBtn() : renderEnrollInClinicForm()
        ]
    });
};
export default EnrollInClinicModal;
